import {
  CustomFetchClient
} from "./chunk-NFLWKIRZ.js";
import {
  panic
} from "./chunk-KKRZEVOT.js";
import {
  BFF_ENV_URL_MAP
} from "./chunk-5IRT6RWL.js";

// generated/search-bff/custom-instance.ts
var customInstance = async (config, apiConfig) => {
  if (!apiConfig?.applicationKey) {
    panic("x-application-key is required");
  }
  const client = new CustomFetchClient({
    defaultBaseURL: BFF_ENV_URL_MAP[apiConfig?.environment ?? "prod"],
    defaultMaxRetryCount: 3,
    defaultRetryDelayMs: 250,
    defaultRetryStatusCodes: [429]
  });
  return client.request(config, apiConfig);
};

export {
  customInstance
};
